/**
 * Business details that have not been supplied yet.
 * Replace [PHONE], [WHATSAPP] and [EMAIL] with the client's real
 * contact details before deploying. Nothing here is invented.
 */
export const siteConfig = {
  brandName: "Jalaram Ad.",
  description: "Outdoor advertising, branding and signage solutions.",
  location: {
    city: "Anand",
    state: "Gujarat",
    country: "India",
  },
  contact: {
    phoneDisplay: "+919428151123",
    phoneHref: "tel:+91 94281 51123",
    // whatsappDisplay: "[WHATSAPP]",
    // whatsappHref: "https://wa.me/[WHATSAPP]",
    email: "info@jalaramads.com",
    emailHref: "mailto:info@jalaramads.com",
  },
} as const;
